import { convertEntities } from '@amzn/awscat-editor';
import { ContentMetadata } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { Link } from 'react-router-dom';
import '../../resources/styles/scss/components/workflow-viewer/workflow-viewer.scss';
import AppContextProps from '../../contexts/AppContextProps';
import { withAppContext } from '../../contexts/AppContext';
import { getContentPath } from '../../common/ContentPaths';

interface Props extends AppContextProps {
  contentId: string;
  metadata: ContentMetadata;
  navigateBackTo?: string;
}

const ReadOnlyContentViewerLink = ({ contentId, metadata, navigateBackTo, appContext }: Props) => {
  return (
    <Link
      to={{
        pathname: getContentPath({ contentId, mode: 'draft', role: 'read-only' }),
        state: { navigateBackTo },
      }}
      className="no-text-decoration"
    >
      {convertEntities(metadata.contentName, appContext.entities)}
    </Link>
  );
};

export default withAppContext(ReadOnlyContentViewerLink);
